import dayjs from 'dayjs'
import { qcopy, trimEndZero } from '@u'
import { _transferBasalData, _transferBigDosageBarData, _heightEquilToBigDosageV, _evenVerticalDashLine, labelSize, _tempBasalDuration } from '@u/reportHelperPump'
import { getBigDosageData, getBigDosageType, universalFontFamily } from '@u/reportHelper'
import Rect from './canvasRect.js'
// window.Rect = Rect
// window.dayjs = dayjs

const _gap = 0.4

function _noop(msg, ...rest) {
  console.error(`[ChartDailyPumpHelper的_logUtil里头没有相应的函数]${msg}`, ...rest)
}
const _logUtil = {
  derror: _noop,
  log: _noop,
  error: _noop
}

export function _registerLogger(extra = {}) {
  Object.assign(_logUtil, extra)
}

export function _createVerticalDashLineWithBigDosage(bigDosage = [], extra = {}, withRectLabel = false) {
  const { lfw, lfs, value } = extra || {}
  const { date } = value || {}
  
  const pvr = 0.2 // 垂直
  const phr = 0.4 // 水平
  const oneLineCfgCom = {
    silent: true, // 鼠标悬停事件  true没有，false有
    symbol: 'none',
    lineStyle: {
      type: 'dashed',
      color: '#999',
      width: 0 // 去掉垂直分割线
    },
    label: {
      show: withRectLabel,
      position: 'start',
      // distance: [0, lfs * 0.5],
      distance: [0, lfs * 0.5],
      padding: [lfs * pvr, lfs * phr, lfs * pvr, lfs * phr],
      fontSize: lfs * 0.8,
      fontWeigt: lfw,
      color: 'white',
      backgroundColor: '#0F7A44',
      formatter: '' // 如果用函数的话，得手动加进去，不能写在这里，因为qcopy的时候会丢失掉
    }
  }
  
  function labelFormatter(params = {}) {
    const { data, dataIndex } = params
    return `${dataIndex + 1}`
  }
  
  const rst = []
  
  bigDosage.forEach((bD, bI) => {
    const { data, check_time, duration, totalDuration, extendIdFirstOne, type } = bD
    const isDual = `${type}` === '2'
    
    const cfg = qcopy(oneLineCfgCom)
    cfg.label.formatter = labelFormatter
    
    if (extendIdFirstOne) {
      // 分割成多条记录的延长大剂量，只有第一条才去考虑下标(包含双波里的延长量和单独的延长量)
      cfg.xAxis = +dayjs(check_time).add(Math.floor((totalDuration / 2) / 1000), 'second')
    } else {
      if (!isDual) {
        cfg.xAxis = +dayjs(check_time).add(Math.floor((duration / 2) / 1000), 'second')              
      } else {
        // console.error(`双波`, bD)
        const { check_time2, true_check_time2 } = bD // 双波第一个是立即量这个立即量大概率是会给一个宽度的，所以导致找中点失误
        if (check_time2 && true_check_time2) {
          const padding = dayjs(check_time2) - dayjs(true_check_time2)
          cfg.xAxis = +dayjs(check_time).add(Math.floor(((duration + padding) / 2) / 1000), 'second')
        } else {
          cfg.xAxis = +dayjs(check_time).add(Math.floor((duration / 2) / 1000), 'second')          
        }
      }
    }
    
    rst.push(cfg)
  })
  
  _evenVerticalDashLine(rst, dayjs(date), {
    gap: 60 * 25,
    lfs
  })
  
  return rst
}

export function _whatBasalsRange(_basals = [], timepoint) {
  const rst = {
    index: -1,
    value: undefined
  }
  
  if (!timepoint) return rst
  let recordTimeDayjs = +dayjs(timepoint)
  if (!_basals || !_basals.length) {    
    return rst
  }
  const last = _basals[_basals.length - 1]
  const lastT = last[0]
  
  // const lastTstr = dayjs(lastT).format('YYYY-MM-DD HH:mm:ss')
  // const ts = dayjs(timepoint).format('YYYY-MM-DD HH:mm:ss')
  // if (dayjs(timepoint).format('YYYY-MM-DD') === '2023-06-02') {
  //   if (lastTstr === ts) {
  //     debugger      
  //   }
  // }
  if (lastT - recordTimeDayjs < 0) {
    // timepoint时间超过_basals最大的那个时间戳
    // 那么将timepoint设成最后一个_basals的时间戳
    recordTimeDayjs = lastT
  }
  let _v = -1
  let _vIndex = -1
  do {
    const l = _basals.length
    for (let i = 0; i < l; i++) {
      const basal = _basals[i]
      const time = dayjs(basal[0])
      const value = basal[1]
      const nextB = _basals[i + 1]
      if (nextB === undefined || i >= (l - 1)) { // 最后一个_basals
        if (time - recordTimeDayjs <= 0) {
          // 找到
          _v = value
          _vIndex = i
          break // 已找到，break
        } else {
          break          
        }
      }
      const time2 = dayjs(nextB[0])
      
      if (time - recordTimeDayjs <= 0 && time2 - recordTimeDayjs > 0) {
        _v = value
        _vIndex = i
        break // 已找到，break
      }
    }
    /* eslint-disable-next-line*/
  } while (false)
  if (_vIndex >= 0) {
    rst.index = _vIndex
    rst.value = _v
  }
  
  return rst
}

export function _getType(r) {
  return getBigDosageType(r)
}
export function _factoryRect(data = [], type = '0', extra = {}) { // type 0: 立即大剂量(普通量)、1: 延长大剂量、 2: 双波大剂量
  const { onlyRect, onlyLabel, bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors, lfs } = extra
  const _bigDosageTypeColorsLinear = bigDosageTypeColorsLinear
  const _bigDosageTypeColorsLinearOpacityStart = 0.2
  
  const _data = _getRectBarData(data)
  
  const opt = { // 大剂量
    name: '大剂量矩形图type' + type,
    type: 'line',
    yAxisIndex: 0,
    // data: bigDosage,
    symbol: 'none',
    lineStyle: {
      width: 0
    },
    borderRadius: [20, 20, 0, 0],
    barBorderRadius: [20, 20, 0, 0],
    markArea: {
      silent: true, // not responding to mouse events
      borderRadius: [20, 20, 0, 0],
      barBorderRadius: [20, 20, 0, 0],
      label: {
        show: true
      },
      itemStyle: {
        borderJoin: 'round',
        borderRadius: [20, 20, 0, 0],
        barBorderRadius: [20, 20, 0, 0],
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: `rgba(${_bigDosageTypeColorsLinear[type]['r']}, ${_bigDosageTypeColorsLinear[type]['g']}, ${_bigDosageTypeColorsLinear[type]['b']}, 1)` },
            { offset: 1, color: `rgba(${_bigDosageTypeColorsLinear[type]['r']}, ${_bigDosageTypeColorsLinear[type]['g']}, ${_bigDosageTypeColorsLinear[type]['b']}, ${_bigDosageTypeColorsLinearOpacityStart})` }
          ]
        },
      },
      data: _data
    }
  }
  
  return { opt, rectData: _data, rects: _data.map(arr => {
    const s = arr[0]['xAxis']
    const $s = dayjs(s)
    const stime = +($s.startOf('day'))
    const etime = +($s.endOf('day'))
    return new Rect(arr, { stime, etime, isLabel: false })
  }) }
}

export function _factoryLabels(data = [], extra = {}) { // type 0: 立即大剂量(普通量)、1: 延长大剂量、 2: 双波大剂量
  const { onlyRect, onlyLabel, bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors, lfs } = extra
  const _bigDosageTypeColorsLinear = bigDosageTypeColorsLinear
  const _bigDosageTypeColorsLinearOpacityStart = 0.2
  
  const _data = (_getRectBarData(data, true).filter(arr => arr && arr[1] && !arr[1]['ds']))
  
  const ndata = _data.map(arr => {
    const [obj1, obj2] = arr
    const { yAxis, tv, td, ds, groupId, extendId, type, isDualFirstRecord, dualExtendDuration, dualExtendValue } = obj2
    return [obj1.xAxis, yAxis, tv, td, ds, obj2.xAxis, type, groupId, extendId, -1, isDualFirstRecord, dualExtendDuration, dualExtendValue]
  })
  // ndata = _evenLabelData(ndata)
  
  const opt = { // 大剂量
    name: '大剂量label图',
    type: 'line',
    yAxisIndex: 0,
    // data: bigDosage,
    symbol: 'none',
    lineStyle: {
      width: 0
    },
    borderRadius: [20, 20, 0, 0],
    barBorderRadius: [20, 20, 0, 0],    
  }  
  
  opt['symbolSize'] = 0
  opt['symbol'] = 'circle' // 不能none，直接none的话,text会不见了。所以通过symbolSize为0来控制symbol的隐藏
  opt['data'] = ndata
  const $l = opt['label'] = {
    show: false
  }
  
  _logUtil.derror(`_factoryLabels `, {
    opt,          
    data,
    _data
  })
  
  return { opt, rectData: _data, rects: (_data.map(arr => {
    const s = arr[0]['xAxis']
    const $s = dayjs(s)
    const stime = +($s.startOf('day'))
    const etime = +($s.endOf('day'))
    const dontShow = arr[1]['ds']
    if (dontShow) {
      return null
    } else {
      return new Rect(arr, { stime, etime, isLabel: true })
    }
  })).filter(v => !!v) }
}

export function _drawRectsToCanvas(rects = [], extra = {}) { // type 0: 立即大剂量(普通量)、1: 延长大剂量、 2: 双波大剂量
  const { isBasal = false } = extra
  const ndata = rects.map((rect, i) => {
    const { groupId, extendId, type, td, tv, x, width, y, barStartX, barWidth, barHeight, isDualFirstRecord, dualExtendValue, dualExtendDuration } = rect
    const ds = false // dont show
    const xend = +x + (width)
    
    const rst = [x, y, tv, td, ds, xend, type, groupId, extendId, i, barStartX, barWidth, barHeight, isDualFirstRecord, dualExtendDuration, dualExtendValue]
    return rst
  })
  const _marklines = []
  ndata.forEach(arr => {
    const ds = arr[4]
    if (!ds) {
      const tv = arr[2]
      const x = arr[0]
      const xend = arr[5]
      // const i = arr[9]
      const uiD = !isBasal ? _transferBigDosageBarData(tv) : _transferBigDosageBarData(_heightEquilToBigDosageV(_transferBasalData(tv)))
      const offsetY = arr[1]

      const barStartX = arr[10]
      const barWidth = arr[11]
      const barHeight = arr[12]
      if (xend - x >= 0) {
        if (!isBasal) {
          if (!((x - (barStartX + barWidth) > 0) || (xend - barStartX < 0))) {
            // 说明大剂量标签和矩形柱子的x轴有重合
            // 那么markline就直接垂直画上去
            const rst = [
              {
                coord: [x, uiD]
              },
              {
                coord: [x, +offsetY + _gap]
              }
            ]          
            _marklines.push(rst)
          } else {
            // 说明标签和矩形柱子的x轴没有重合，即辅助线要画出折线
            const foldPoint = [barStartX, +offsetY]
            let startPoint
            let endPoint
            if (xend - barStartX <= 0) {
              // 标签在柱子左边
              endPoint = [xend, +offsetY]
              startPoint = [barStartX, barHeight] 
            } else {
              // 标签在柱子右边
              endPoint = [x, +offsetY]
              startPoint = [barStartX + barWidth, barHeight]
            }          

            _marklines.push([
              {
                coord: startPoint
              },
              {
                coord: foldPoint
              }
            ])

            _marklines.push([
              {
                coord: foldPoint
              },
              {
                coord: endPoint
              }
            ])
          }

          // // test,dev: 增加label的border-bottom辅助线
          // _marklines.push([
          //   {
          //     coord: [x, +offsetY + _gap]
          //   },
          //   {
          //     coord: [xend, +offsetY + _gap]
          //   }
          // ])
          // // End test,dev: 增加label的border-bottom辅助线
        } else {
          // 基础率label(isBasal)
          const xZebraRectMiddle = barStartX + barWidth / 2 // 斑马矩形的中间位置

          if (!((x - (barStartX + barWidth) > 0) || (xend - barStartX < 0))) {
            // 说明标签和矩形柱子的x轴有重合
            // 那么markline就直接垂直画上去
            const rst = [
              {
                coord: [xZebraRectMiddle, uiD]
              },
              {
                coord: [xZebraRectMiddle, +offsetY + _gap]
              }
            ]          
            _marklines.push(rst)
          } else {
            // 说明标签和矩形柱子的x轴没有重合，即辅助线要画出折线
            const foldPoint = [barStartX, +offsetY]
            let startPoint
            let endPoint
            if (xend - barStartX <= 0) {
              // 标签在柱子左边
              // 临时基础率的矩形图
              endPoint = [xend, +offsetY]
              startPoint = [xZebraRectMiddle, barHeight]
            } else {
              // 标签在柱子右边
              // 临时基础率的矩形图.即柱子===临时基础率矩形
              endPoint = [x, +offsetY]
              startPoint = [xZebraRectMiddle, barHeight]
            }

            _marklines.push([
              {
                coord: startPoint
              },
              {
                coord: foldPoint
              }
            ])

            _marklines.push([
              {
                coord: foldPoint
              },
              {
                coord: endPoint
              }
            ])
          }
        }
      }
    }
  })
  const _ml = _marklines.map(arr => {
    const c = arr[0].coord
    c[2] = dayjs(c[0]).format('HH:mm:ss')

    const c2 = arr[1].coord
    c2[2] = dayjs(c2[0]).format('HH:mm:ss')

    return arr
  })
  // window._ml = _ml
  const ml = { // markLine
    silent: true,
    // symbol: 'none',
    lineStyle: {
      // color: '#333',
      color: 'rgba(51, 51, 51, 0.4)', // #333: rgb(51, 51, 51)
      type: 'dashed',
      width: '1'
    },
    symbolSize: 0,
    data: _ml
  }
  
  const opt = { // 大剂量
    name: '大剂量label图',
    type: 'line',
    yAxisIndex: 0,
    // data: bigDosage,
    symbol: 'none',
    lineStyle: {
      width: 0
    },
    borderRadius: [20, 20, 0, 0],
    barBorderRadius: [20, 20, 0, 0],    
  }
  
  opt['markLine'] = ml
  opt['symbolSize'] = 0
  opt['symbol'] = 'circle' // 不能none，直接none的话,text会不见了。所以通过symbolSize为0来控制symbol的隐藏
  opt['data'] = ndata
  const $l = opt['label'] = {
    show: true,
    position: 'top',
    distance: 0,
    // offset: [],
    align: 'left',
    borderWidth: 0,
    borderColor: 'black',
    textStyle: {
      strokeWidth: 4, // 文案的描边
      stroke: 'red'
    },
    rich: _getRichObj(undefined, extra),
    formatter: (params) => {
      const { data = [] } = params
      const [x, y, _tv, td, ds, endX, type, groupId, extendId, i, barStartX, barWidth, barHeight, isDualFirstRecord, dualExtendDuration, dualExtendValue] = data
      const tv = trimEndZero(+_tv.toFixed(3))
      let str = ''
      if (!ds) {
        // if (`${tv}` === '3') {
        //   _logUtil.derror(`3 formatter`, data)
        // }
        if (['0', '1', '2'].includes(`${type}`)) {
          if (`${isDualFirstRecord}` === 'true') { // 双波第一条记录. 10,10 30m
            const dualExtendV = trimEndZero(+dualExtendValue.toFixed(3))
            str = `{v${type}|${tv}} | {v|${dualExtendV}}`
          } else {
            // 非双波
            str = `{v${type}|${tv}}`
          }
          
          if (td) {
            str = `${str}\t{bg${type}|${td}}`
          }
        } else {
          str = `{v|${tv}}`
          if (td) {
            str = `${str}\t{bg|${td}}`
          }
        }
      }

      // return `${i}-${str}-${y}-${tv}`
      // return `${i}-${str}`
      return str
      // return `${tv}-${y}-${_transferBigDosageBarData(tv)}`
      // if (td) {
      // return `${i}-${str}`        
      // } else {
      //   return str
      // }
    }
  }

  _logUtil.derror(`_drawRectToCanvas `, {
    opt,          
    data: ndata
  })
  
  return { opt }
}

export function _getRectBarData(data = [], isLabelRect = false) {
  return (data.map(c => { // markArea          
    const { duration, duration4ui, data, type: ct, extendIdFirstOne, dualFirstRecord } = c
    const type = `${ct}`.trim()
    const isDual = type === '2' || (c && c.groupId)
    const isDualFirstRecord = isDual && dualFirstRecord
    const isExtended = type === '1' // 延长大剂量
    const isSplitedExtend = isExtended && c.extendId && !c.groupId // 同一个延长量，可能中途会打多个立即大剂量，从而被分割成多段
    const isDualSplitedExtend = isExtended && c.extendId && c.groupId
    // const isDual = c && c.groupId // 双波

    const _fmt = 'MM/DD HH:mm:ss'
    const rst = [
      {
        xAxis: +dayjs(c.check_time),
        xAxisTxtP1: dayjs(c.check_time).format(_fmt),
        yAxis: 0
      },
      {
        // name: `${_transferBigDosageBarData(getBigDosageData(c, true))},tv:${getBigDosageData(c, true)}`,
        xAxis: +dayjs(c.check_time).add(Math.floor(c.duration / 1000), 'second'),
        xAxisTxtP2: dayjs(c.check_time).add(Math.floor(c.duration / 1000), 'second').format(_fmt),
        yAxis: _transferBigDosageBarData(getBigDosageData(c, true)),
        tv: getBigDosageData(c, true),
        td: '',
        groupId: c.groupId,
        extendId: c.extendId,
        type
      }
    ]

    if (isDualFirstRecord) {
      let dualExtendDurations = 0
      const dualExtendValue = c['dualTotalBolus'] - getBigDosageData(c, true)

      const keys = Object.keys(c)
      keys.forEach(k => {
        if (/^true_duration[0-9]+/i.test(k)) {
          // 双波里头的延长量的持续时间
          dualExtendDurations += (+c[k])
        }
      })
      Object.assign(rst[1], { // 为了label标签正确渲染出信息数据使用.
        'isDualFirstRecord': true,
        'dualExtendDuration': dualExtendDurations,
        'dualExtendValue': dualExtendValue
      })
      if (dualExtendDurations) { // 需要显示duration的label,例如  10,10 30m
        Object.assign(rst[1], { // 为了label标签正确渲染出信息数据使用.
          'td': `${_tempBasalDuration(dualExtendDurations / 1000)}`
        })        
      }
    }
    
    if (isSplitedExtend || isDualSplitedExtend) {
      rst[0]['xAxis'] = +dayjs(c.check_time).subtract(15, 'second') // 双波的延长量,浮动一下,免得差几秒导致最后有一条细细的白线
      if (extendIdFirstOne) {
        rst[1]['xAxis'] = +dayjs(c.check_time).add(Math.floor(c.duration4ui / 1000), 'second')
        const tv = getBigDosageData(c, false)
        // if (isDualSplitedExtend) {
        //   debugger
        // }
        Object.assign(rst[1], {
          yAxis: _transferBigDosageBarData(tv),
          tv,
          td: `${_tempBasalDuration(c.totalDuration / 1000)}`
        })
      } else {
        return undefined // 不画bigDosage的柱子(或者，不画bigDosage的label);被分割成多个record的延长量，除了第一个记录之外，后面的记录直接跳过不画
      }
    }
    return rst
  })).filter(v => v)
}

export function _getRichObj(_type = 'all', extra = {}) {
  const { bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors, lfs } = extra
  try {
    const type = `${_type}`

    const r = {
      v: {
        fontFamily: universalFontFamily,
        fontSize: labelSize,        
        align: 'left',
        backgroundColor: `transparent`,
      },
      bg: {
        fontFamily: universalFontFamily,
        color: 'white',
        fontSize: labelSize * 0.8,
        // padding: [0.1 * lfs, 0.6 * lfs, 0.6 * lfs, 0.1 * lfs],
        padding: [0.1 * lfs, 0.2 * lfs],
        align: 'left',
        borderRadius: 0.1 * lfs
      }
    }
    if (['0', '1', '2'].includes(type)) {
      const bgC = `rgba(${bigDosageTypeColorsLinear[type]['r']}, ${bigDosageTypeColorsLinear[type]['g']}, ${bigDosageTypeColorsLinear[type]['b']}, 0.8)`
      r['bg']['backgroundColor'] = bgC
    } else {
      // 根据types遍历
      ['0', '1', '2'].forEach(type => {
        const { v, bg } = r
        const vk = `v${type}`
        const bgk = `bg${type}`
        r[vk] = { ...v }
        r[bgk] = { ...bg }

        const bgC = `rgba(${bigDosageTypeColorsLinear[type]['r']}, ${bigDosageTypeColorsLinear[type]['g']}, ${bigDosageTypeColorsLinear[type]['b']}, 0.8)`
        r[bgk]['backgroundColor'] = bgC
      })
    }
    return r
  } catch (error) {
    if (bigDosageTypeColorsLinear) {
      console.error('被捕获:' + error)      
    }
    return
  }
}

export function _evenLabelData(_ndata = []) {
  return _ndata
  // const ndata = _ndata.filter(arr => !arr[4]).sort((f, s) => {
  //   return f[0] - s[0]
  // })
  // const durationWidth = 2.8 * (60 * 60 * 1000) // 持续时间的文案宽度差不多持续的时间(微秒)
  // const _g = 1.8
  // const extendGaps = [_g, _g * 2, _g * 3]
  
  // const rst = ndata.map(arr => {
  //   const [sx, yAxis, tv, td, ds, ex, type, groupId, extendId] = arr
  //   const isExtend = `${type}` === '1'    
  //   const rst = [...arr]
  //   if (isExtend) {
  //     rst[1] = +rst[1] + _g      
  //   }
  //   return rst
  // })

  // return rst
}

export function _isSplittedExtendDosageAndNotInDual(r = {}) {
  // 非双波的、被分割成多条记录的延长大剂量
  const { extendId, groupId, type } = r
  return `${type}` === '1' && !groupId && extendId
}

export function _isNotInDual(r = {}) {
  const { groupId } = r
  return !groupId
}
